import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { environment } from '@sp-client/environments/environment';
import { ButtonComponent } from '../button/button.component';

@Component({
	selector: 'sp-issues',
	imports: [CommonModule, ButtonComponent],
	templateUrl: './issues.component.html',
	styleUrl: './issues.component.scss'
})
export class IssuesComponent {
	issue = input<'wait' | 'error'>('wait');
	waitTitle = `We're still doing some heavy lifting!`;
	waitSubtitle = `Check back soon to see your dashboard and itinerary.`;
	errorTitle = `Something went wrong`;
	errorSubtitle = `Refresh the page or wait and try again later`;
	emailSubject = 'Scoutly Plans Support - Error';
	emailTo = environment.supportEmail;

	sendEmail() {
		window.location.href = `mailto:${this.emailTo}?subject=${this.emailSubject}`;
	}
}
